import { cn } from "../../lib/cn.js";

interface BetaBadgeProps {
  className?: string;
}

export function BetaBadge({ className }: BetaBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 rounded-full border border-violet-400/30 bg-violet-500/15 px-1.5 py-0.5 text-[8px] font-semibold uppercase tracking-wide text-violet-300",
        className
      )}
    >
      Beta
    </span>
  );
}
